import assert from "assert";

export class IQuestionsDataStore {
    create(questions) {
        assert(false, 'QuestionsDataStore.create function not implimented')
    }

    retrieve(product, version){
        assert(false, 'QuestionsDataStore.retrieve function not implimented')
    }

    store(questions){
        assert(false, 'QuestionsDataStore.store function not implimented')
    }

    list(){
        assert(false, 'QuestionsDataStore.list function not implimented')
    }

    remove(version){
        assert(false, 'QuestionsDataStore.remove function not implimented')
    }
}

export default IQuestionsDataStore